import Vue from 'vue';
import stockTransformer from './../../transformers/stock';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('RefreshStockProducts');
  resolve(stockTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(stockTransformer.fetch(errors));
};

export default stock => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/stocks', stock)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/store.js